var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { memo, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { trpc } from 'root/src/client/v2/trpc/trpc';
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient';
import { CONNECTED_CHANNELS_ROUTE_ID, CREATOR_KEYS_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds';
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
import Checkmark from 'root/src/client/public/checkmark.png';
import CloseIcon from '@mui/icons-material/Close';
import { useIsCreatorExclusively } from 'root/src/client/v2/auth/hooks/useIsCreator';
import { useIsGiveawayEnter } from 'root/src/client/v2/giveaways/features/GiveawayAutoEnter/hooks/useIsGiveawayEnter';
export const CreatorOnboardingProgressBar = memo(() => {
    const { steps, percent, isVisible, setIsOpen, } = useOnboardingProgress();
    if (!isVisible) {
        return null;
    }
    return (<div className="CreatorOnboardingProgressBar my-6 flex flex-col motion-safe:animate-pop-up bg-dark-2 py-4 px-2 gap-6 lg:gap-2 items-center justify-around relative">
			<Status percent={percent}/>
			<Steps steps={steps}/>
			<button title="Close" onClick={() => setIsOpen(false)} type="button" className="p-4 absolute right-1 top-0 text-light-3 text-sm font-semibold hover:text-light-4">
				<CloseIcon />
			</button>
		</div>);
});
// NOTE: legacy code handler, do not use if not necessary
// eslint-disable-next-line import/no-mutable-exports,@typescript-eslint/no-empty-function
export let updateOnboardingProgressImperative = () => { };
const useOnboardingProgress = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { isGiveawayAutoEnter } = useIsGiveawayEnter();
    const [isOpen, setIsOpen] = useState(true);
    const { isCreator } = useIsCreatorExclusively();
    const getCreatorOnboardingStateQuery = trpc.creators.getCreatorOnboardingState.useQuery(undefined, {
        enabled: isCreator,
    });
    updateOnboardingProgressImperative = () => __awaiter(void 0, void 0, void 0, function* () {
        yield getCreatorOnboardingStateQuery.refetch();
    });
    const steps = [
        {
            isCompleted: Boolean((_a = getCreatorOnboardingStateQuery.data) === null || _a === void 0 ? void 0 : _a.hasConnectedAccount),
            label: 'Connect your channel',
            onClick: () => {
                pushRouteClient({
                    routeId: CONNECTED_CHANNELS_ROUTE_ID,
                });
            },
        },
        {
            label: 'Find a drop to join',
            isCompleted: Boolean((_b = getCreatorOnboardingStateQuery.data) === null || _b === void 0 ? void 0 : _b.hasFoundDrop),
            onClick: () => {
                window.location.href = routeUrls.drops({ onboarding: true });
            },
            disabled: !((_c = getCreatorOnboardingStateQuery.data) === null || _c === void 0 ? void 0 : _c.hasConnectedAccount),
        },
        {
            isCompleted: Boolean((_d = getCreatorOnboardingStateQuery.data) === null || _d === void 0 ? void 0 : _d.hasAcceptedDare),
            label: 'Accept a dare',
            onClick: () => {
                pushRouteClient({
                    href: routeUrls.drops({ onboarding: true }),
                });
            },
            disabled: !((_e = getCreatorOnboardingStateQuery.data) === null || _e === void 0 ? void 0 : _e.hasFoundDrop),
        },
        {
            isCompleted: Boolean((_f = getCreatorOnboardingStateQuery.data) === null || _f === void 0 ? void 0 : _f.hasSubmittedDare),
            label: 'Deliver a dare',
            onClick: () => {
                pushRouteClient({
                    href: routeUrls.drops({ onboarding: true }),
                });
            },
            disabled: !((_g = getCreatorOnboardingStateQuery.data) === null || _g === void 0 ? void 0 : _g.hasAcceptedDare),
        },
        {
            label: 'Check your rewards',
            onClick: () => {
                pushRouteClient({
                    routeId: CREATOR_KEYS_ROUTE_ID,
                });
            },
            disabled: !((_h = getCreatorOnboardingStateQuery.data) === null || _h === void 0 ? void 0 : _h.hasSubmittedDare),
            isCompleted: Boolean((_j = getCreatorOnboardingStateQuery.data) === null || _j === void 0 ? void 0 : _j.hasCheckedRewards),
        },
    ];
    const percent = Math.round((steps.filter(step => step.isCompleted).length / steps.length) * 100);
    const isCompleted = percent === 100;
    // Giveaway onboarding UI might conflict
    const isVisible = !isGiveawayAutoEnter && isCreator && isOpen && !(isCompleted
        || getCreatorOnboardingStateQuery.isLoading
        || ((_k = getCreatorOnboardingStateQuery.data) === null || _k === void 0 ? void 0 : _k.isCompleted));
    return {
        steps,
        percent,
        isCompleted,
        isVisible,
        setIsOpen,
    };
};
const Status = memo((props) => {
    const { percent } = props;
    return (<div className="flex select-none justify-center flex-initial items-center gap-4 my-2">
			<div className="size-20 flex justify-center items-center">
				<span className="absolute text-center">{percent}%</span>
				<CircleProgressBar progress={percent}/>
			</div>
			<div className="text-lg">Complete these steps to get the most out of Dare Drop</div>
		</div>);
});
const CircleProgressBar = ({ progress }) => {
    return (<svg viewBox="0 0 36 36" className="size-20">
			<path d="M18 2.0845
                            a 15.9155 15.9155 0 0 1 0 31.831
                            a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#04172D" strokeWidth="3" strokeDasharray="100, 100"/>
			<path d="M18 2.0845
                            a 15.9155 15.9155 0 0 1 0 31.831
                            a 15.9155 15.9155 0 0 1 0 -31.831" fill="none" stroke="#5C40B6" strokeWidth="3" strokeDasharray={`${progress},100`}/>
		</svg>);
};
const Steps = memo((props) => {
    const { steps } = props;
    return (<ul className="flex flex-col lg:flex-row flex-initial gap-10 lg:gap-6 my-2">
			{steps.map((step) => {
            return (<li key={step.label} className="flex flex-initial">
						<div className="flex select-none flex-initial gap-4 items-center justify-center">
							{step.isCompleted ? <img className="size-7" src={Checkmark.src} alt="checkmark"/> : <Unmarked muted={step.disabled}/>}
							<span onClick={step.onClick} className={twMerge('text-sm uppercase', (step.isCompleted || step.disabled) ? 'text-light-4' : 'text-link cursor-pointer')}>{step.label}</span>
						</div>
					</li>);
        })}
		</ul>);
});
export const Unmarked = memo((props) => {
    const { muted } = props;
    return (<div className={twMerge('size-6 aspect-square rounded-full border-2 border-white drop-shadow-teal-glow', muted && 'drop-shadow-none border-light-4')}/>);
});
